<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
               <el-form-item label="登录账号:" prop="account">
                <el-input  placeholder="" v-model="searchFrom.account"></el-input>
              </el-form-item>
              <el-form-item label="业务类型:" prop="businessCode">
                <el-select placeholder="请选择" v-model="searchFrom.businessCode">
                  <el-option
                    v-for="item in bussinessType"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="注册来源:" prop="sourceType">
                <el-select placeholder="请选择" v-model="searchFrom.sourceType">
                  <el-option
                    v-for="item in RegisteredSource"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态:" prop="status">
                <el-select placeholder="请选择" v-model="searchFrom.status">
                  <el-option
                    v-for="item in status"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="注册时间:" prop="createTime">
                <el-date-picker
                      style="width: 300px"
                      v-model="searchFrom.createTimes"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="变更状态:" prop="changeStatus">
                <el-select placeholder="请选择" v-model="searchFrom.changeStatus">
                  <el-option
                    v-for="item in changeState"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item> -->
        </div>
       <div class="searchBtnBox">
         <el-form-item >
            <el-button type="primary" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick" height="100%"   style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <div>
                  <el-button type="text" size="mini" @click="delDeiver(scope.row)" v-if="scope.row.status == 1 && btnFlg[2]">删除</el-button>
                  <el-button type="text" size="mini" @click="bgzhFn(scope.row)" v-if="btnFlg[1]">变更账号</el-button>
                  <!-- <el-button type="text" size="mini" @click="bgzhFn(scope.row)" v-if="btnFlg[1]&&scope.row.status==3&&(scope.row.changeStatus==1001||scope.row.changeStatus==1401||scope.row.changeStatus==1402)">变更账号</el-button> -->
                  </div>
                </template>
        </el-table-column>
        <el-table-column label="登录账号" min-width="160">
          <template slot-scope="scope">
            <div>
              <span style="color: #0c46a2;cursor: pointer;" @click="lookFn(scope.row)" v-if="scope.row.status != 1">{{scope.row.account}}</span>
              <span v-if="scope.row.status == 1">{{scope.row.account}}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column property="auditStatus" label="业务类型" >
          <template scope="scope">
            {{[ "网络货运", "仓库装卸" ][scope.row.auditStatus-1]}}
          </template>
        </el-table-column> -->
        <el-table-column property="businessCode" label="业务类型" :formatter="statusFormat" min-width="160"></el-table-column>
        <el-table-column property="sourceType" label="注册来源" min-width="160">
          <template scope="scope">
            {{[ "Web端", "APP端", "微信端" ][scope.row.sourceType-1]}}
          </template>
        </el-table-column>
        <el-table-column property="status" label="状态" min-width="150" >
          <template scope="scope">
            {{[ "未认证","车辆未认证","正常","停用" ][scope.row.status-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" min-width="170" :formatter="dateTimeFormat"  label="注册时间"></el-table-column>
        <!-- <el-table-column property="changeStatus" label="变更状态" min-width="140" :formatter="statusFormat1"> </el-table-column> -->
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog :title="title"
    @close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="bgzhMark"
    width="500px"
    center>
    <el-form :inline="true" :rules="rules" :model="bgzhFrom" ref="bgzhFrom" class="demo-form-inline jiaoyan" label-width="160px" size="mini">
      <el-form-item label="原账号:" prop="account"  style="margin-top: 28px;">
        <el-input  placeholder="" maxlength="11" :readonly="true" class="disabled" v-number-input.float="0" v-model="bgzhFrom.account"></el-input>
      </el-form-item>
      <el-form-item label="新账号:" prop="newAccount">
        <el-input  placeholder="" maxlength="11" @blur="zhBlur()" v-number-input.float="0" v-model="bgzhFrom.newAccount"></el-input>
      </el-form-item>
      <div style="margin: 10px 121px;color: red">
        <span style="display:inline-block"> 注：变更账号需要得到使用者许可</span>
        <span style="display:inline-block;margin-left:30px">密码为原密码</span>
      </div>
    </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bgzhMark = false">取 消</el-button>
        <el-button type="primary" @click="bgzhSave()">确 定</el-button>
      </span>
    </el-dialog>
     <!-- 查看 -->
    <el-dialog title="查看详情" :close-on-click-modal="false" class="detailBox" :close-on-press-escape="false" :visible.sync="dialoglook" @close="closeDialog" width="1225px" center>
      <span>
        <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="160px" size="mini">
        <div class="inpBox">
              <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
              <el-form-item label="身份证号:" prop="identityNo">
                <span>{{addFrom.identityNo}}</span>
              </el-form-item>
               <el-form-item label="司机姓名:" prop="name">
                <span>{{addFrom.name}}</span>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <span>{{addFrom.mobile}}</span>
              </el-form-item>
              <el-form-item label="所属单位/个人:" prop="driverTenantName">
               <span>{{addFrom.driverTenantName}}</span>
              </el-form-item>
              <el-form-item label="驾驶证号:" prop="licenseNum">
               <span>{{addFrom.licenseNum}}</span>
              </el-form-item>
               <el-form-item label="身份证有效期:" prop="identityExpiringDate">
                 <span>{{addFrom.identityExpiringDate}}</span>
                </el-form-item>
                <el-form-item label="驾驶证档案号:" prop="certificateNum">
                  <span>{{addFrom.certificateNum}}</span>
              </el-form-item>
                <el-form-item label="准驾车型:" prop="quasiDrivingModel" >
                 <span>{{addFrom.quasiDrivingModel}}</span>
                </el-form-item>
                <el-form-item label="驾驶证发证机关:" prop="issueAuthority" >
                 <span>{{addFrom.issueAuthority}}</span>
                </el-form-item>
                <el-form-item label="驾照起始日期:" prop="validPeriodFrom" >
                 <span>{{addFrom.validPeriodFrom|dateFormat1}}</span>
                </el-form-item>
                <el-form-item label="驾照截止日期:" prop="validPeriodTo">
                 <span>{{addFrom.validPeriodTo}}</span>
                </el-form-item>
              <el-form-item label="道路运输从业资格证:"  prop="qualificationNum">
               <span style="width:560px">{{addFrom.qualificationNum}}</span>
              </el-form-item>
              <el-form-item label="行政区域:" prop="xname" >
               <span style="width:560px">{{addFrom.provinceName}}-{{addFrom.cityName}}-{{addFrom.areaName}}</span>
              </el-form-item>
              <el-form-item label="常走路线:" prop="useLines">
               <div style="width:560px">{{addFrom.useLines}}</div>
              </el-form-item>
               <div class="box">
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.identityPhoto1Url"
                      :preview-src-list="[addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl]">
                    </el-image>
                    <h6 class="is-need">身份证正面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.identityPhoto2Url"
                      :preview-src-list="[addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url]">
                    </el-image>
                    <h6  class="is-need">身份证背面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.appendix1Url"
                      :preview-src-list="[addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url]">
                    </el-image>
                    <h6  class="is-need">驾驶证正面</h6>
                </div>
                <div class="imgBox">
                     <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.appendix2Url"
                      :preview-src-list="[addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url]">
                    </el-image>
                    <h6  class="is-need">驾驶证背面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.qualificationPhotoUrl"
                      :preview-src-list="[addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url]">
                    </el-image>
                    <h6  class="is-need">道路运输从业资格证</h6>
                </div>
              </div>

        </div>
      </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialoglook = false" type="primary">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 二次确认 -->
    <!-- <el-dialog title="提示"
    @close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="recallMark"
    width="500px"
    center>
      <div>
        <span style="text-align: center;display:block;margin-top:20px">登录账号变更成功，是否立即变更油卡账号？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="recallSave">是</el-button>
        <el-button @click="recallMark = false">否</el-button>
      </span>
    </el-dialog> -->
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { detailDriver, cDriverAccountList, deleteAccount, updateAccount } from '@/api/vgs-driver2.0'
// import { changeFuelCardAccount } from '@/api/consignment'
export default {
  data () {
    return {
      recallMark: false,
      // changeState: [
      //   { name: '未变更', value: 1001 },
      //   { name: '变更中', value: 1403 },
      //   { name: '变更成功', value: 1401 },
      //   { name: '变更失败', value: 1402 }
      // ],
      bgzhMark: false,
      bgzhFrom: {},
      bussinessType: [
        { name: '网络货运', value: '4-1' },
        { name: '仓库装卸', value: '4-2' }
      ],
      RegisteredSource: [
        { name: 'Web端', value: 1 },
        { name: 'APP端', value: 2 },
        { name: '微信端', value: 3 }
      ],
      status: [
        { name: '未认证', value: 1 },
        { name: '车辆未认证', value: 2 },
        { name: '正常', value: 3 },
        { name: '停用', value: 4 }
      ],
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: false,
      addFrom: { jzcq: 2, sfzcq: 2 },
      ktzhFrom: {},
      title: '',
      rules: {
        name: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        xname: [
          { required: true, message: '请选择省市县', trigger: 'blur' }
        ],
        driverClassify: [
          { required: true, message: '请选择司机所属', trigger: ['blur', 'change'] }
        ],
        identityNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        // account: [
        //   { required: true, message: '请输入联系电话', trigger: 'blur' },
        //   this.rule.mobile
        // ],
        licenseNum: [
          { required: true, message: '请输入驾驶证号', trigger: 'blur' }
        ],
        certificateNum: [
          { required: true, message: '请输入驾驶证号档案号', trigger: 'blur' }
        ],
        qualificationNum: [
          { required: true, message: '请输入从业资格证号', trigger: 'blur' }
        ],
        driverTenantName: [
          { required: true, message: '请输入所属单位/个人', trigger: 'blur' }
        ],
        driverTenant: [
          { required: true, message: '请输入所属单位/个人', trigger: 'blur' }
        ],
        quasiDrivingModel: [
          { required: true, message: '请选择准驾车型', trigger: 'blur' }
        ],
        issueAuthority: [
          { required: true, message: '请输入驾驶证发证机关', trigger: 'blur' }
        ],
        identityExpiringDate: [
          { required: true, message: '请选择身份证有效期', trigger: 'blur' }
        ],
        validPeriodFrom: [
          { required: true, message: '请选择驾照起始日期', trigger: 'blur' }
        ],
        validPeriodTo: [
          { required: true, message: '请选择驾照结束日期/个人', trigger: 'blur' }
        ],
        newAccount: [
          { required: true, message: '请输入新账号', trigger: 'blur' }
        ],
        account: [
          { required: true, message: '请输入原账号', trigger: 'blur' }
        ]
      },
      total: 0,
      dialoglook: false,
      btnFlg: [],
      btnIdArr: ['00IM060100', '00IM060200', '00IM060300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/freightDriver')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // recallSave () {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: '正在处理...'
    //   })
    //   changeFuelCardAccount({ driverId: this.bgzhFrom.id }).then(res => {
    //     loading.close()
    //     this.$message({
    //       message: '油卡变更成功',
    //       type: 'success'
    //     })
    //     this.recallMark = false
    //     this.getList(this.searchFrom)
    //   }).catch(error => {
    //     this.$message({
    //       showClose: true,
    //       message: error.message,
    //       type: 'error',
    //       onClose () {
    //         loading.close()
    //       }
    //     })
    //   })
    // },
    // statusFormat1 (row, column, cellValue) {
    //   switch (cellValue) {
    //     case 1001:
    //       return '未变更'
    //     case 1101:
    //       return '变更中'
    //     case 1102:
    //       return '变更中'
    //     case 1201:
    //       return '变更中'
    //     case 1202:
    //       return '变更中'
    //     case 1301:
    //       return '变更中'
    //     case 1302:
    //       return '变更中'
    //     case 1103:
    //       return '变更中'
    //     case 1203:
    //       return '变更中'
    //     case 1303:
    //       return '变更中'
    //     case 1401:
    //       return '变更成功'
    //     case 1402:
    //       return '变更失败'
    //   }
    // },
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case '4-1':
          return '网络货运'
        case '4-2':
          return '仓库装卸'
      }
    },
    zhBlur () {
      if (this.bgzhFrom.newAccount == this.bgzhFrom.account) {
        this.$alert('新账号与原账号相同！', '系统提示')
        this.$set(this.bgzhFrom, 'newAccount', '')
      }
    },
    bgzhFn (row) {
      this.bgzhMark = true
      this.title = '变更账号'
      this.$set(this.bgzhFrom, 'account', row.account)
      this.$set(this.bgzhFrom, 'id', row.id)
      this.$set(this.bgzhFrom, 'sourceType', 1)
    },
    bgzhSave () {
      this.$refs.bgzhFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateAccount(this.bgzhFrom).then(res => {
            loading.close()
            // this.$alert('变更账号！', '系统提示')
            this.bgzhMark = false
            // this.recallMark = true
            this.$message({
              message: '变更账号成功',
              type: 'success'
            })
            // changeFuelCardAccount({ driverId: this.bgzhFrom.id }).then(res => {
            //   loading.close()
            //   this.$message({
            //     message: '油卡变更成功',
            //     type: 'success'
            //   })
            //   // this.recallMark = false
            //   this.getList(this.searchFrom)
            // }).catch(error => {
            //   this.$message({
            //     showClose: true,
            //     message: error.message,
            //     type: 'error',
            //     onClose () {
            //       loading.close()
            //     }
            //   })
            // })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // bgzhSave () {
    //   this.$refs.bgzhFrom.validate((valid) => {
    //     if (valid) {
    //       const loading = this.$loading({
    //         lock: true,
    //         text: '正在处理...'
    //       })
    //       updateAccount(this.bgzhFrom).then(res => {
    //         loading.close()
    //         // this.$alert('变更账号！', '系统提示')
    //         this.bgzhMark = false
    //         this.$message({
    //           message: '变更账号成功',
    //           type: 'success'
    //         })
    //         this.getList(this.searchFrom)
    //       }).catch(error => {
    //         this.$message({
    //           showClose: true,
    //           message: error.message,
    //           type: 'error',
    //           onClose () {
    //             loading.close()
    //           }
    //         })
    //       })
    //     }
    //   })
    // },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      cDriverAccountList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 查看
    lookFn (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      detailDriver({ driverId: row.driverId }).then(res => {
        loading.close()
        this.addFrom = res
        // this.FKfrom.SKlist = res.cDriverBankCardList
        this.dialoglook = true
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 删除
    delDeiver (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteAccount({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },

    closeDialog () {
      this.bgzhFrom = {}
      // this.$refs['bgzhFrom'].clearValidate()
      if (this.$refs.bgzhFrom) {
        this.$refs.bgzhFrom.clearValidate()
      }
    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
        // createTime: null
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
// .inpBox .el-date-editor{
//       width: 350px!important;
// }
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
  /deep/ .hide .el-upload--picture-card {
  display: none;
}
}
.addressBox{
  display: flex!important;
  justify-content: space-between;
  margin-bottom: 10px;
  .title{
    margin: 0!important;
  }
}
.FKbox{
  /deep/ .el-form-item--mini.el-form-item{
    margin: 4px;
    margin-bottom: 16px;
  }
}
.box{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .imgBox{
    display: flex;
    margin-left:55px;
    flex-direction: column;

    width: 320px;
    /deep/.el-upload--picture-card{
          width: 320px;
    height: 200px;
    }
  }
  h6{
    text-align: center;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../assets/images/upload1.png);
    background-size: 320px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
          width: 320px;
    height: 200px;
  }
}
.detailBox .el-form-item span{
  display:inline-block;
  width: 225px;
}
.detailBox img{
   width: 320px;
    height: 200px;
}
.detailBox /deep/ .el-date-editor--date .el-input__inner{
  border: none;
  font-size: 14px;
}
// .detailBox /deep/.el-form-item__content{
//   width: 300px;
// }
.jiaoyan .inpBox /deep/.el-date-editor .el-input__inner{
  width: 225px;
}
</style>
